export default __webpack_public_path__ + "static/media/talks_etiqueta_pasado.6c9a4e69.jpg";